import React from "react";
import { ColumnRender, IColumn, RelatedEntityLifecycleConfig } from "../../components/UI/Declarations";

export type { RelatedEntityLifecycleConfig };

export const SITE_RELATED_ENTITY_LIFECYCLE: RelatedEntityLifecycleConfig = {
    deletedMember: "siteIsDeleted",
    activeMember: "siteIsEnabled",
};

export const CUSTOMER_RELATED_ENTITY_LIFECYCLE: RelatedEntityLifecycleConfig = {
    deletedMember: "customerIsDeleted",
    activeMember: "customerIsEnabled",
};

export const LOCATION_RELATED_ENTITY_LIFECYCLE: RelatedEntityLifecycleConfig = {
    deletedMember: "locationIsDeleted",
    activeMember: "locationIsEnabled",
};

export const REG_FACILITY_OPERATION_RELATED_ENTITY_LIFECYCLE: RelatedEntityLifecycleConfig = {
    deletedMember: "regFacilityOperationIsDeleted",
    activeMember: "regFacilityOperationIsActive",
};

function readBooleanFlag(item: Record<string, unknown>, member: string): boolean | undefined {
    const value = item[member];
    if (value === true || value === false) {
        return value;
    }
    return undefined;
}

export function getRelatedEntityTextClassName(
    item: Record<string, unknown>,
    config: RelatedEntityLifecycleConfig
): string | undefined {
    const isDeleted = readBooleanFlag(item, config.deletedMember);
    if (isDeleted === true) {
        return "text-danger text-decoration-line-through";
    }

    const isActive = readBooleanFlag(item, config.activeMember);
    if (isActive === false) {
        return "text-warning";
    }

    return undefined;
}

export function getRelatedEntityTextTitle(
    item: Record<string, unknown>,
    config: RelatedEntityLifecycleConfig
): string | undefined {
    const isDeleted = readBooleanFlag(item, config.deletedMember);
    if (isDeleted === true) {
        return "Deleted";
    }

    const isActive = readBooleanFlag(item, config.activeMember);
    if (isActive === false) {
        return "Disabled";
    }

    return undefined;
}

export function renderRelatedEntityText(
    text: React.ReactNode,
    item: Record<string, unknown>,
    config: RelatedEntityLifecycleConfig
): React.ReactNode {
    const className = getRelatedEntityTextClassName(item, config);
    if (!className) {
        return text;
    }

    const title = getRelatedEntityTextTitle(item, config);
    return (
        <span className={className} title={title} aria-label={title}>
            {text}
        </span>
    );
}

export function relatedEntityTextColumn(options: {
    member: string;
    title: string;
    width: number;
    relatedEntityLifecycle: RelatedEntityLifecycleConfig;
    align?: "start" | "center" | "end";
}): IColumn {
    return {
        member: options.member,
        renderAs: ColumnRender.text,
        title: options.title,
        width: options.width,
        align: options.align,
        relatedEntityLifecycle: options.relatedEntityLifecycle,
    } as IColumn;
}

export function renderRelatedEntityTextFromFlags(
    text: React.ReactNode,
    flags: { isDeleted?: boolean; isActive?: boolean }
): React.ReactNode {
    if (flags.isDeleted === true) {
        return (
            <span className="text-danger text-decoration-line-through" title="Deleted" aria-label="Deleted">
                {text}
            </span>
        );
    }

    if (flags.isActive === false) {
        return (
            <span className="text-warning" title="Disabled" aria-label="Disabled">
                {text}
            </span>
        );
    }

    return text;
}
